import {useHeartbeats} from "../../utils/hooks"
import {minute as oneMinute} from "../../utils/times"


export const UseHeartbeats = ({page, data, frequency = oneMinute}) => {
	useHeartbeats({from: page, type: "heartbeat", ...data}, frequency)
	return null
}
